import { PayloadAction } from '@reduxjs/toolkit';

import { ReportsState } from '../../types';

export const setUnauthorizedReport = (
  state: ReportsState,
  action: PayloadAction<ReportsState['unauthorizedReport']>,
) => {
  state.unauthorizedReport = action.payload;
};
